<script setup lang="ts">
import { useConfirm, VIcons } from '@/shared/ui'
import type { PropType } from 'vue'
import type { AdminConfiguratorTemplateType } from '@/entities/Cabinet'
import { useConfiguratorTemplateDelete } from './../model/api'
import { useRoute } from 'vue-router'
import { useTranslate } from '@/shared/lib'

const props = defineProps({
  item: {
    type: Object as PropType<AdminConfiguratorTemplateType>,
    required: true,
  },
})

const route = useRoute()
const { show } = useConfirm()
const { trs } = useTranslate()

const { isPending, remove } = useConfiguratorTemplateDelete(
  props.item.id,
  Number(route.params.object_id),
)

const clickHandler = () => {
  show({
    confirmFunc: remove,
    title: trs('itf.templates_remove'),
  })
}
</script>

<template>
  <VTooltip location="top" :open-delay="500" :text="$t('itf.delete')">
    <template #activator="{ props: tooltipProps }">
      <VBtn
        icon
        color="error"
        density="compact"
        :loading="isPending"
        v-bind="tooltipProps"
        @click="clickHandler"
      >
        <VIcons type="delete" />
      </VBtn>
    </template>
  </VTooltip>
</template>
